import pageMeta from 'pageMeta/pageMeta';

/***
 *
 * Return the URL that contains a video metadata
 * @param { Number | string } contentId - id of the video
 *
 */
export function getMetadataURL(slug = '') {

    const locale = pageMeta['locale'] || 'en';

    // TODO: Update to non-hardcoded path when we move away from HB;
    // Leaving commented lines below as breadcrumbs for future updates...
    // const cmsDataPath = _get(window, 'server_path.cms_data.fullPath', '');
    // const embed = _get(window.mediaConfig, 'vpm.metaUtil', {});
    // const {
    //     root,
    //     regex,
    //     pattern,
    // } = embed;

    return `/data-service/${locale}/videos/${slug}`;

}

